import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { UtilitiesProvider } from '../../providers/utilities';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { PaymentProvider } from '../../providers/payment';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { TranslateCodePipe } from '../../pipes/translate';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { filter, map, switchMap } from 'rxjs/operators';
import { TicketData } from '../../providers/ticket';
import { IReserveShoppingCart } from '../../models/shopping-cart.model';
import * as clientSelector from '../../ngrx/reducers/client.reducer';

const componentName = 'ButtonShoppingCartComponent';

@Component({
  selector: 'button-shopping-cart',
  templateUrl: 'button-shopping-cart.html'
})
export class ButtonShoppingCartComponent implements OnInit, OnDestroy {

  @Input() configColor: any;
  @Input() viewCartFrom: any;
  @Input() uidTrack: string;
  @Input() eventId: string = '--';
  @Input() forceView: boolean = false; // Este parametro obliga a mostrar el carrito de compra asi no existan productos agregados

  // private userSubscribe: Subscription;
  public shoppingCart$: Observable<any>;
  public clientConfig$: Observable<any>;

  constructor(
    private store: Store<{}>,
    private utilities: UtilitiesProvider,
    private navCtrl: NavController,
    private translatePipe: TranslateCodePipe,
    private paymentData: PaymentProvider,
    private analytics: AnalyticsData,
    public navParams: NavParams,
    private ticketProvider: TicketData,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.clientConfig$ = this.store.select(clientSelector.getClient);
    this.shoppingCart$ = this.store.select(fromAuth.getUser)
      .pipe(
        filter((user) => user != null),
        switchMap((user) => {
          const productSp = this.paymentData.getUserShoppingCart(user.info.id);
          const reserveSp = this.paymentData.getReservesShoppingCart(user.info.id);
          const ticketSp = this.ticketProvider.getUserShoppingCart(user.info.id);
          return Observable.zip(
            productSp.pipe(
              map((sc: any) => sc ? sc.num_products : 0)
            ),
            reserveSp.pipe(
              map((sc: IReserveShoppingCart) => sc ? sc.num_products : 0)
            ),
            ticketSp.pipe(
              map((sc: any) => sc ? sc.num_products : 0)
            ),
          ).pipe(
            map(([products, reserves, tickets]) => ({ products, reserves, tickets })),
          );
        })
      );
  }

  /**
   * Carga el carrito de compra del usuario o muestra un mensaje de que no existen productos en el carrito
   * @param isEmpty
   */
  public shoppinCart(isEmpty = false, values: any) {
    const carts = Object.keys(values).filter(key => values[key] > 0);
    if (isEmpty || carts.length === 0) { 
      return this.utilities.presentToast('You have no products added in the shopping cart!'); 
    }
    if (carts.length === 1) {
      switch (carts[0]) {
        case 'products':
          this.trackAnalytics(_ACTIONS.viewCartCatalog);
          return this.navCtrl.push('ShoppingCart', { eventId: this.eventId });
        case 'reserves':
          this.trackAnalytics(_ACTIONS.viewCartReserves);
          return this.navCtrl.push('ShoppingCartReservesPage', { eventId: this.eventId });
        case 'tickets':
          this.trackAnalytics(_ACTIONS.viewCartTicket);
          return this.navCtrl.push('ShoppingTicketCartPage', { eventId: this.eventId });
        default:
          return this.modalCtrl.create('ModalSelectShoppingCartPage', { viewCartFrom: this.viewCartFrom, eventId: this.eventId, values, uidTrack: this.uidTrack }).present();
      }
    } else {
      return this.modalCtrl.create('ModalSelectShoppingCartPage', { viewCartFrom: this.viewCartFrom, eventId: this.eventId, values, uidTrack: this.uidTrack }).present();
    }
  }

  public trackAnalytics(action) {
    this.analytics.savePageTrackOnFirestore(
      componentName,
      action,
      this.uidTrack,
      { params: this.navParams.data, viewCartFrom: this.viewCartFrom }
    );
  }

  public canShowNumNotifications(data) {
    const carts = Object.keys(data).filter(k => data[k] != 0);
    return carts.length === 1 ? data[carts[0]] : false;
  }

  ngOnDestroy() {
    // if (this.userSubscribe) this.userSubscribe.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/components/button-shopping-cart/button-shopping-cart.ts